<template>
  <b-container fluid>
    <b-row>
      <b-col xl="12" lg="12" sm="12">
            <iq-card>
                <template v-slot:body>
                    <b-row>
                        <b-col xl="12" lg="12" sm="12">
                            <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
                                <b-form @submit.prevent="handleSubmit(storeUpdate)" @reset.prevent="reset">
                                    <b-row>
                                         <b-col xl="6" lg="6" sm="8">
                                            <ValidationProvider name="Component" vid="component_id" rules="required">
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="4"
                                                    label-for="component_id"
                                                    slot-scope="{ valid, errors }"
                                                >
                                                <template v-slot:label>
                                                    {{$t('infoServiceManagement.component_name')}} <span class="text-danger">*</span>
                                                </template>
                                                    <b-form-select
                                                        plain
                                                        v-model="manage.component_id"
                                                        :options="componentList"
                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                        >
                                                        <template v-slot:first>
                                                            <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                                                        </template>
                                                    </b-form-select>
                                                    <div class="invalid-feedback">
                                                    {{ errors[0] }}
                                                    </div>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                        <b-col xl="6" lg="5" sm="8">
                                            <ValidationProvider name="Service" vid="service_id" rules="required">
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="4"
                                                    label-for="service_id"
                                                    slot-scope="{ valid, errors }"
                                                >
                                                <template v-slot:label>
                                                    {{$t('infoServiceManagement.service_name')}} <span class="text-danger">*</span>
                                                </template>
                                                    <b-form-select
                                                        plain
                                                        v-model="manage.service_id"
                                                        :options="serviceList"
                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                        >
                                                        <template v-slot:first>
                                                            <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                                                        </template>
                                                    </b-form-select>
                                                    <div class="invalid-feedback">
                                                    {{ errors[0] }}
                                                    </div>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col xl="3" lg="6" sm="8">
                                            <ValidationProvider name="Enter Question" vid="question" rules="required">
                                                <b-form-group
                                                class="row"
                                                slot-scope="{ valid, errors }"
                                                >
                                                <b-form-input
                                                    :placeholder="$t('infoServiceManagement.enter_question')"
                                                    :id="index"
                                                    v-model="manage.question"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                    ></b-form-input>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                        <b-col xl="3" lg="6" sm="8">
                                            <ValidationProvider name="Enter Question (bn)" vid="question_bn" rules="required">
                                                <b-form-group
                                                class="row ml-1"
                                                slot-scope="{ valid, errors }"
                                                >
                                                <b-form-input
                                                    :placeholder="$t('infoServiceManagement.enter_question_bn')"
                                                    :id="index"
                                                    v-model="manage.question_bn"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                    ></b-form-input>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                        <b-col xl="3" lg="6" sm="8">
                                            <ValidationProvider name="Enter Answer" vid="answer" rules="required">
                                                <b-form-group
                                                class="row  ml-1"
                                                slot-scope="{ valid, errors }"
                                                >
                                                <b-form-input
                                                    :placeholder="$t('infoServiceManagement.enter_answer')"
                                                    :id="index"
                                                    v-model="manage.answer"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                    ></b-form-input>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                        <b-col xl="3" lg="6" sm="8">
                                            <ValidationProvider name="Enter Answer (bn)" vid="answer_bn" rules="required">
                                                <b-form-group
                                                class="row ml-1"
                                                slot-scope="{ valid, errors }"
                                                >
                                                <b-form-input
                                                    :placeholder="$t('infoServiceManagement.enter_answer_bn')"
                                                    :id="index"
                                                    v-model="manage.answer_bn"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                    ></b-form-input>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                    </b-row>
                                    <div class="row">
                                        <div class="col-sm-3"></div>
                                        <div class="col text-right">
                                            <b-button type="submit" variant="primary" class="mr-2">{{ saveBtnName }}</b-button>
                                            &nbsp;
                                            <b-button variant="danger" class="mr-1" @click="$bvModal.hide('modal-4')">{{ $t('globalTrans.cancel') }}</b-button>
                                        </div>
                                    </div>
                                </b-form>
                            </ValidationObserver>
                        </b-col>
                    </b-row>
                </template>
            </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { core } from '../../../../../config/pluginInit'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RestApi, { commonServiceBaseUrl } from '../../../../../config/api_config'
import { manageFaqstore, manageFaqUpdate } from '../../api/routes'

export default {
    props: ['id'],
    components: {
        ValidationObserver,
        ValidationProvider
    },
    created () {
        if (this.id) {
            const tmp = this.getManageData()
            this.manage = tmp
        }
        this.getComponentlist()
        this.getServiceList()
    },
    mounted () {
        core.index()
    },
    data () {
        return {
            totalPost: 0,
            saveBtnName: this.id ? this.$t('globalTrans.update') : this.$t('globalTrans.save'),
            manage: {
                component_id: 0,
                service_id: 0,
                question: '',
                question_bn: '',
                answer: '',
                answer_bn: ''
            },
            componentList: [],
            serviceList: []
        }
    },
    computed: {
        directoryTypeList: function () {
            const objectData = this.$store.state.commonObj.directoryTypeList
            return objectData.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.id, text: obj.name_bn }
                } else {
                    return { value: obj.id, text: obj.name }
                }
            })
        }
    },
    watch: {
         'manage.component_id': function (newVal, oldVal) {
            this.serviceList = this.getServiceList(newVal)
        }
    },
    methods: {
        getManageData () {
            const tmpData = this.$store.state.list.find(item => item.id === this.id)
            return JSON.parse(JSON.stringify(tmpData))
        },
        async storeUpdate () {
            this.$store.dispatch('mutateCommonProperties', { loading: true })
            try {
                let result = null
                const loadinState = { loading: false, listReload: true }
                if (this.id) {
                    result = await RestApi.putData(commonServiceBaseUrl, `${manageFaqUpdate}/${this.id}`, this.manage)
                } else {
                    result = await RestApi.postData(commonServiceBaseUrl, manageFaqstore, this.manage)
                }
                this.$store.dispatch('mutateCommonProperties', loadinState)
                if (result.success) {
                    this.$toast.success({
                        title: 'Success',
                        message: this.id ? 'Data updated successfully' : 'Data save successfully',
                        color: '#D6E09B'
                    })
                    this.$bvModal.hide('modal-edit')
                } else {
                    this.$refs.form.setErrors(result.errors)
                }
            } catch (error) {
                this.$toast.error({
                title: 'Error',
                message: 'something went wrong! Please, try again.'
                })
                this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
            }
        },
        getComponentlist () {
            const listObject = this.$store.state.commonObjCommonConfig.componentList.filter(item => item.status === 0)
            this.componentList = listObject.map((obj, index) => {
                if (this.$i18n.locale === 'bn') {
                return { value: obj.value, text: obj.text_bn }
                } else {
                return { value: obj.value, text: obj.text }
                }
            })
        },
        getServiceList (componentId) {
            const serviceList = this.$store.state.commonObjCommonConfig.serviceComList.filter(item => item.status === 0)
            if (componentId) {
                const serviceData = serviceList.filter(service => service.component_id === componentId)
                const tmpList = serviceData.map((obj, index) => {
                    if (this.$i18n.locale === 'bn') {
                        return { value: obj.value, text: obj.text_bn }
                    } else {
                        return { value: obj.value, text: obj.text_en }
                    }
                })
                return tmpList
            }
        },
        add () {
            const tmpquestions = {
                question: '',
                question_bn: '',
                answer: '',
                answer_bn: ''
            }
            const key1 = parseInt(this.manage.question.length - 1)
            const item = this.manage.question[key1]
            let isEmpty = true
            Object.keys(item).map(key => {
                if (item[key] === '' || item[key] === 0) {
                    isEmpty = false
                }
            })
            if (isEmpty === true) {
                this.manage.question.push(tmpquestions)
            }
        },
        remove (key) {
            this.manage.question.splice(key, 1)
        }
    }
}

</script>
